import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import profileReducer, * as profileActions from 'redux/modules/profile';
import { clearSurveyState as _clearSurveyState } from 'redux/modules/survey';
import { Helmet } from 'react-helmet';
import { provideHooks } from 'redial';
import Button from 'components/MuiComponents/Button';
import MuiAvatar from '@material-ui/core/Avatar';
// import Loading from 'react-loading-animation';
import SwipeableViews from 'react-swipeable-views';
import MuiAppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';
import AuthForm from 'components/AuthForm/Loadable';
import styled, { css, ThemeProvider } from 'styled-components';
import idx from 'idx';
import Gallery from 'components/Gallery/LoadableFunction';
import ExpandableText from 'components/ExpandableText/ExpandableText';
import MuiVerifiedIcon from '@material-ui/icons/VerifiedUserRounded';
import MuiCommentIcon from '@material-ui/icons/CommentRounded';
import ReviewDialog from 'components/Profile/ReviewDialog/Loadable';
import ComingSoonDialog from 'components/Profile/ComingSoonDialog/Loadable';
import TestimonialCard from 'components/TestimonialCard/Loadable';
import autoBind from 'auto-bind';
import Upperfirst from 'lodash.upperfirst';
import isEmpty from 'lodash.isempty';

import theme from '../../theme/styled-theme';
import { sendGtagEvent } from '../../utils/gtag';
import config from '../../config';
import replaceS3WithCDN from '../../utils/replaceS3WithCDN';

const cdnPrefix = `${config.cdnUrl}/misc`;
const DIALOGS = {
  PRELOGIN: 'PRELOGIN',
  AUTHFORM: 'AUTHFORM',
};
const Root = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 768px;
  margin: 0 auto;
`;

const Sticky = styled.div`
  display: block;
`;

const StickyBottom = styled.div`
  left: 0;
  position: fixed;
  display: flex;
  width: 100%;
  z-index: 1000;
  bottom: 0;
  background: #ffffff;
  box-shadow: 0 -1px 2px 0 #edeeee;
  padding: 0.5rem 1rem;
`;

const BottomLeft = styled.div`
  display: flex;
  flex: 1 0 0;
  align-items: center;
`;

const DriversDesc = styled.div`
  display: flex;
  flex-direction: column;
`;

const DriverName = styled.h4`
  margin: 0;
`;

const PreviewPhoto = styled.div`
  display: inline-flex;
  width: calc((100vw - 56px) / 3);
  height: calc((100vw - 56px) / 3);
  max-width: 155px;
  max-height: 155px;
  margin: 0 6px;
  border-radius: 8px;
  overflow: hidden;
  background: ${props => props.url ? `url("${props.url}") center center / cover` : '#EFF0F1'};
`;

const GalleryContainer = styled.div`
  min-height: 107px;
  margin: 0 -6px;
`;

// const ReviewsCount = styled.span`
//   color: ${props => props.theme.greyLight200};
//   font-weight: 400;
//   line-height: 18px;
// `;

const BottomAvatar = styled(MuiAvatar)`
  && {
    width: 36px;
    height: 36px;
    margin-right: 8px;
  }
`;

const ReviewPromptRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const PrompHeader = styled.h3`
  font-size: 1.375rem;
  font-family: ${props => props.theme.fontFamilyRaleway};
  color: ${props => props.theme.greyLight300};
`;

const ReviewPromptAvatar = styled(MuiAvatar)`
  && {
    width: 116px;
    height: 116px;
    margin: 1.25rem auto;
  }
`;

const ReviewPromptHeader = styled.h4`
  font-size: 1.25rem;
  font-weight: 400;
  color: ${props => props.theme.greyLight300};
  margin-bottom: 0.75rem;
`;

const ReviewPromptDesc = styled.p`
  margin: 0.75rem 0;
  line-height: 1.5625rem;
`;

const ReviewRrompActions = styled.div`
  width: 88%;
  position: absolute;
  bottom: 100px;
`;


const DriverProfileHeaderRoot = styled.div`
  display: flex;
  margin: 0 0.75rem;
  padding: 0.5rem 0 1.5rem;
`;

const DriverOverviewSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 50%;
  margin: 0 12px;
  vertical-align: top;
`;

const PictureSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 0 112px;
  max-width: 112px;
  margin: 0 12px;
  vertical-align: top;
`;

const Avatar = styled(MuiAvatar)`
  && {
    width: 58px;
    height: 58px;
  }
`;

const Verified = styled.h6`
  display: flex;
  font-weight: 400;
  align-items: center;
  margin-bottom: 0;
  text-align: center;
  color: ${props => props.theme.greyLight200};
`;

const VerifiedIcon = styled(MuiVerifiedIcon)`
  && {
    font-size: 17px;
    margin-right: 6px;
    color: ${props => props.theme.primaryGreen};
  }
`;

const CommentIcon = styled(MuiCommentIcon)`
  && {
    font-size: 17px;
    margin-right: 6px;
    color: ${props => props.theme.secondaryGreen};
  }
`;

const ShortDesc = styled.p`
  vertical-align: top;
  color: ${props => props.theme.greyLight200};
`;

const styles = () => ({
  reviewCardRootClass: {
    width: '100%!important',
    flex: '0 0 100%!important',
    boxSizing: 'border-box!important'
  },

  reviewCardInnerClass: {
    padding: '16px 0px!important',
    background: '#FFFFFF!important',
    boxShadow: 'none!important'
  }
});

const TabContainer = styled.div``;

// const LoadingContainer = styled.div`
//   padding: 3rem 1rem;
//   margin: 0 auto;
// `;

const AppBar = styled.div`
  width: 100%;
`;

const DriverProfileTab = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
`;

const DriverReviewsTab = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
`;

const SectionHeader = styled.h4`
  position: relative;
  color: ${props => props.theme.greyLight300};
`;

const InfoHeader = styled.h4`
  margin: 0.75rem 0 0.5rem;
  color: ${props => props.theme.greyLight200};
`;

const Info = styled.h6`
  margin: 0;
  font-weight: 400;
  text-transform: capitalize;
`;

const Section = styled.section`
  margin: 16px 0 22px;
`;

const { isProfileLoaded, loadProfile } = profileActions;

@withStyles(styles)
@provideHooks({
  inject: ({ store }) => store.inject({ profile: profileReducer }),
  fetch: async ({ store: { dispatch, getState }, params }) => {
    if (!isProfileLoaded(getState(), params.id)) {
      await dispatch(loadProfile(params.id));
    }
  }
})
@connect(
  state => ({
    profile: state.profile && state.profile.profile,
    auth: state.auth,
    mobileDetect: state.mobileDetect,
    sentNotifiedMe: state.profile && state.profile.sentNotifiedMe,
    sendingNotifiedMe: state.profile && state.profile.sendingNotifiedMe,
  }),
  {
    ...profileActions,
    clearSurveyState: _clearSurveyState,
  }
)
@withRouter
class Profile extends Component {
  static propTypes = {
    profile: PropTypes.objectOf(PropTypes.any).isRequired,
    mobileDetect: PropTypes.objectOf(PropTypes.any).isRequired,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    auth: PropTypes.objectOf(PropTypes.any).isRequired, // eslint-disable-line react/no-unused-prop-types

    /* Redux Props */
    sentNotifiedMe: PropTypes.bool.isRequired,
    sendingNotifiedMe: PropTypes.bool.isRequired,

    /* Redux Action */
    registerNotifyMe: PropTypes.func.isRequired,
    resetNotifyMe: PropTypes.func.isRequired,
    clearSurveyState: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  constructor(props) {
    super(props);

    autoBind.react(this);

    this.state = {
      galleryOpen: false,
      galleryIndex: 0,
      reviewDialogOpen: false,
      comingSoonDialogOpen: false,
      currentReviewPromt: DIALOGS.PRELOGIN,
      value: 0
    };
  }

  setGalleryOpen(status) {
    this.setState({
      galleryOpen: status,
    });
  }

  setGalleryIndex(index) {
    this.setState({
      galleryIndex: index,
    });
  }

  handleTabChange(event, value) {
    this.setState({ value });
  }

  handleChangeIndex(index) {
    this.setState({ value: index });
  }

  handleReviewDialogOpen() {
    this.setState({
      reviewDialogOpen: true,
    });
  }

  handleReviewDialogClose() {
    this.setState({
      reviewDialogOpen: false,
      currentReviewPromt: DIALOGS.PRELOGIN,
    });
  }

  handleComingSoonDialogOpen() {
    this.setState({
      comingSoonDialogOpen: true,
    });
  }

  handleComingSoonDialogClose() {
    const { resetNotifyMe } = this.props;
    resetNotifyMe();
    this.setState({
      comingSoonDialogOpen: false,
    });
  }

  renderProfileHeader(onReviewButtonClick) {
    const { clearSurveyState } = this.props;
    const name = idx(this.props, _ => _.profile.display_name);
    const bio = idx(this.props, _ => _.profile.bio);
    const isVerified = idx(this.props, _ => _.profile.isVerified);
    const profilePicture = idx(this.props, _ => _.profile.profile_photo_thumbnail_url);
    const profileEmptyHolder = `${config.cdnUrl}/misc/profile-empty.png`;

    return (
      <DriverProfileHeaderRoot>
        <PictureSection>
          <Avatar alt={name} src={isEmpty(profilePicture) ? profileEmptyHolder : profilePicture} />
          {isVerified && (
            <Verified>
              <VerifiedIcon />
              <span>Verified Driver</span>
            </Verified>
          )}
        </PictureSection>
        <DriverOverviewSection>
          <h4>{name}</h4>
          <ShortDesc>
            <ExpandableText text={bio} maxLength={50} />
          </ShortDesc>
          <Button
            variant="outlined"
            size="small"
            overwritestyles={css`
              border-color: #04844b;
              color: #04844b;
              width: 170px;
            `}
            fullWidth={false}
            onClick={e => {
              e.stopPropagation();
              onReviewButtonClick();
              clearSurveyState();
            }}
          >
            <CommentIcon />
            <span>Write an Review</span>
          </Button>
        </DriverOverviewSection>
      </DriverProfileHeaderRoot>
    );
  }

  renderCustomStyle() {
    // const { mobileDetect } = this.props;
    const { reviewDialogOpen, comingSoonDialogOpen } = this.state;
    return (
      <div>
        {/* eslint-disable */}
        <style
          dangerouslySetInnerHTML={{
            __html: `
            #ownrides-toolbar {
              position: relative!important;
            }
            #sitetoolbar-position {
              position: fixed!important;
            }
            #intercom-container iframe.intercom-launcher-frame, #intercom-container iframe.intercom-launcher-discovery-frame {
              bottom: 70px!important;
              ${reviewDialogOpen || comingSoonDialogOpen ? 'display: none;' : ''}
              z-index: 1058!important;
            }
            #intercom-container .intercom-messenger-frame {
              bottom: 134px!important;
              ${reviewDialogOpen || comingSoonDialogOpen ? 'display: none;' : ''}
            }
          `
          }}
        />
        {/* eslint-enable */}
      </div>
    );
  }

  renderStickyBottom() {
    const name = idx(this.props, _ => _.profile.display_name);
    const profilePicture = idx(this.props, _ => _.profile.profile_photo_thumbnail_url);
    // const reviewsCount = idx(this.props, _ => _.profile.reviewsCount);
    const profileEmptyHolder = `${cdnPrefix}/profile-empty.png`;

    return (
      <StickyBottom>
        <BottomLeft>
          <BottomAvatar src={isEmpty(profilePicture) ? profileEmptyHolder : profilePicture} alt={name} />
          <DriversDesc>
            <DriverName>{name}</DriverName>
            {/* <ReviewsCount>{reviewsCount} Reviews</ReviewsCount> */}
          </DriversDesc>
        </BottomLeft>
        <Button
          variant="contained"
          color="primary"
          size="medium"
          onClick={e => {
            e.stopPropagation();
            this.handleComingSoonDialogOpen();
            sendGtagEvent('Click on comming soon button', 'interaction', name);
          }}
        >
          Book Me
        </Button>
      </StickyBottom>
    );
  }

  renderAuthForm() {
    const driverId = idx(this.props, _ => _.profile.id);
    const slug = idx(this.props, _ => _.profile.slug);

    return (
      <AuthForm
        hideHeader
        handleDialogClose={this.handleClose}
        presetRedirectPath={`/profile/${slug}/${driverId}/review`}
      />
    );
  }

  renderReviewDriverPromp() {
    const name = idx(this.props, _ => _.profile.name);
    const profilePicture = idx(this.props, _ => _.profile.profile_photo_thumbnail_url);
    const profileEmptyHolder = `${cdnPrefix}/profile-empty.png`;

    return (
      <ReviewPromptRoot>
        <PrompHeader>Review Your Driver</PrompHeader>
        <ReviewPromptAvatar src={isEmpty(profilePicture) ? profileEmptyHolder : profilePicture} alt={name} />
        <ReviewPromptHeader>{ name }</ReviewPromptHeader>
        <ReviewPromptDesc>Your review helps other travelers to find us, and it help us to learn and grow <span aria-label="<love>" role="img">️️❤️</span>️</ReviewPromptDesc>
        <ReviewRrompActions>
          <Button
            color="primary"
            variant="contained"
            fullWidth
            onClick={e => {
              e.stopPropagation();
              sendGtagEvent('Click on continue to write reivew', 'interaction', name);
              this.setState({
                currentReviewPromt: DIALOGS.AUTHFORM,
              });
            }}
          >
            Continue
          </Button>
          <ReviewPromptDesc>You’ll need to login to your account first.</ReviewPromptDesc>
        </ReviewRrompActions>
      </ReviewPromptRoot>
    );
  }


  renderDriverProfile() {
    const name = idx(this.props, _ => _.profile.display_name);
    const bio = idx(this.props, _ => _.profile.bio);
    const languages = idx(this.props, _ => _.profile.languages) || [];
    const seatCapacity = idx(this.props, _ => _.profile.seating_capacity);
    // const reviewsCount = idx(this.props, _ => _.profile.reviewsCount);
    // const reviewScore = idx(this.props, _ => _.profile.reviewScore);
    // const tours = idx(this.props, _ => _.profile.tours);
    const photos = idx(this.props, _ => _.profile.photos);
    const location = idx(this.props, _ => _.profile.city.name);
    const {
      galleryOpen,
      galleryIndex
    } = this.state;

    const languagesFlatten = languages
      .map(language => Object.keys(language).map(key => Upperfirst(key)).join(', '))
      .join(', ');

    const photosCount = (photos && photos.length) || 0;

    const joinedPhotos = photos ? photos.map(p => ({
      src: replaceS3WithCDN(p.image_url),
      thumbnail: replaceS3WithCDN(p.thumbnail_url)
    })) : [];

    const previewPhotos = joinedPhotos ? joinedPhotos.slice(0, 3) : [];

    return (
      <DriverProfileTab>
        <Section>
          <SectionHeader>Verified Info</SectionHeader>

          <InfoHeader>Language</InfoHeader>
          <Info>{languagesFlatten}</Info>

          <InfoHeader>Location Based</InfoHeader>
          <Info>{location}</Info>

          <InfoHeader>Vehicle Capacity</InfoHeader>
          <Info>2 - {seatCapacity} Guests</Info>

          {/* <Highlight>
            <HighlightNumber>{reviewsCount}</HighlightNumber>
            <HighlightText>Reviews</HighlightText>

            <HighlightNumber>
              {reviewScore}
              <small>/ 5</small>
            </HighlightNumber>
            <HighlightText>Stars</HighlightText>
          </Highlight> */}

        </Section>

        <Divider />

        <Section>
          <SectionHeader>Hi, I'm {name}</SectionHeader>
          <p>{bio}</p>
        </Section>

        <Divider />
        {
          photosCount
            ? (
              <Section>
                <SectionHeader>
                  {`Photos (${photosCount})`}
                  <Button
                    onClick={e => {
                      e.stopPropagation();
                      this.setGalleryOpen(true);
                    }}
                    overwritestyles={css`
                      color: #04844B;
                      position: absolute;
                      right: 0;
                    `}
                    size="small"
                  >
                    VIEW MORE
                  </Button>
                </SectionHeader>
                {
                  <GalleryContainer>
                    {
                      previewPhotos.map(({ thumbnail }, index) => (
                        <PreviewPhoto
                          url={thumbnail}
                          key={`preview-photo-${index}`}
                          onClick={() => {
                            this.setGalleryIndex(index);
                            this.setGalleryOpen(true);
                          }}
                        />
                      ))
                    }
                    <Gallery
                      open={galleryOpen}
                      images={joinedPhotos}
                      toggleLightboxOpen={this.setGalleryOpen}
                      controlCurrentIndex={galleryIndex}
                    />
                  </GalleryContainer>
                }
              </Section>
            )
            : null
        }

        {
          photosCount
            ? <Divider />
            : null
        }

        {/* {
          tours && tours.length
            ? <Section>
              <SectionHeader>Tours Created by {name}</SectionHeader>
              {
                tours.map(tour => <DriverProfileTourCard tour={tour} />)
              }
            </Section>
            : null
        } */}
      </DriverProfileTab>
    );
  }

  renderDriverReviews() {
    const { classes = {} } = this.props;
    const reviews = idx(this.props, _ => _.profile.reviews);
    return (
      <DriverReviewsTab>
        {reviews &&
          reviews.map((review, index) => (
            <TestimonialCard
              key={index}
              review={review}
              rootClass={classes.reviewCardRootClass}
              innerClass={classes.reviewCardInnerClass}
              isTruncate
              noSeparationLine
            />
          ))}
      </DriverReviewsTab>
    );
  }

  renderDriverProfileTabs() {
    const { value } = this.state;
    return (
      <div style={{ width: '100%' }}>
        <Sticky enabled top={0} innerZ={1000}>
          <AppBar>
            <MuiAppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={this.handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
              >
                <Tab label="Profile" />
                <Tab label="Reviews" />
              </Tabs>
            </MuiAppBar>
          </AppBar>
        </Sticky>

        <SwipeableViews
          axis="x"
          index={value}
          onChangeIndex={this.handleChangeIndex}
          animateHeight
        >
          <TabContainer>{this.renderDriverProfile()}</TabContainer>
          <TabContainer>{this.renderDriverReviews()}</TabContainer>
        </SwipeableViews>
      </div>
    );
  }

  render() {
    const {
      history,
      mobileDetect,
      registerNotifyMe,
      sentNotifiedMe,
      sendingNotifiedMe,
    } = this.props;
    const { reviewDialogOpen, comingSoonDialogOpen, currentReviewPromt } = this.state;

    const slug = idx(this.props, _ => _.profile.slug);
    const bio = idx(this.props, _ => _.profile.bio);
    const name = idx(this.props, _ => _.profile.display_name);
    const driverId = idx(this.props, _ => _.profile.id);
    const userEmail = idx(this.props, _ => _.auth.user.email);
    const accessToken = idx(this.props, _ => _.auth.user.owt.access_token);
    const facebookOg = `${cdnPrefix}/driver-profile-fb-og.jpg`;
    const pathname = __SERVER__
      ? `${config.app.url}/profile/${slug}`
      : `${window.location.origin}${window.location.pathname}`;
    const description = bio
      ? `${bio} - ${config.app.description}`
      : 'Book recommended private drivers for your tours in Taiwan. Customize your tour and get price for taxi tour guides, car hires, private drivers in Taipei, Hualien, Taichung, Kaohsiung and more.';

    return (
      <ThemeProvider theme={theme}>
        <div>
          <Helmet title={`${name} - Your Professional private driver guide`} />
          <Helmet
            meta={[{
              property: 'og:image',
              content: facebookOg,
            }, {
              property: 'og:url',
              content: pathname,
            }, {
              property: 'og:title',
              content: `${name} - Your professional private driver guide`,
            }, {
              property: 'og:description',
              content: description,
            }, {
              name: 'description',
              content: description,
            }, {
              id: 'english-canonical-url',
              content: ''
            }]}
          />

          { this.renderCustomStyle() }

          <Root>
            {
              this.renderProfileHeader(() => {
                if (accessToken) {
                  sendGtagEvent('Click on write reivew(logged in)', 'interaction', name);
                  history.push(`/profile/${slug}/${driverId}/review`);
                } else {
                  sendGtagEvent('Click on write reivew(not log in)', 'interaction', name);
                  this.handleReviewDialogOpen();
                }
              })
            }

            { this.renderDriverProfileTabs() }

            <Sticky>
              { this.renderStickyBottom() }
            </Sticky>
          </Root>

          <ReviewDialog
            isOpen={reviewDialogOpen}
            mobileDetect={mobileDetect}
            handleClose={this.handleReviewDialogClose}
          >
            {
              currentReviewPromt === DIALOGS.PRELOGIN
                ? this.renderReviewDriverPromp()
                : this.renderAuthForm()
            }
          </ReviewDialog>

          <ComingSoonDialog
            isOpen={comingSoonDialogOpen}
            mobileDetect={mobileDetect}
            handleClose={this.handleComingSoonDialogClose}
            sendingRequest={sendingNotifiedMe}
            success={sentNotifiedMe}
            presetEmail={userEmail}
            onSendClick={email => {
              registerNotifyMe({
                email,
                feature: `Book Me Feature: ${name}`,
              });
            }}
          />
        </div>
      </ThemeProvider>
    );
  }
}

export default Profile;
